import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  Button,
} from "@chakra-ui/react";
import { getSupabase, supabasePublic, supabaseSchema } from "../components/supabaseClient";
import { bucketName_files, prompts } from "../components/env";
import { generateMedADocsPath, generateMedADocsFolderPath } from "./documentUtilities";

const DocumentCreationModal = ({ isOpen, onClose, selectedDate, navigate }) => {
  const [name, setName] = useState("SOAP_note");
  const [id, setId] = useState("1");
  const [loading, setLoading] = useState(false);
  const year = selectedDate ? selectedDate.split("-")[0] : "UnknownYear";

  const handleCreateDocument = async () => {
    const supabase = await getSupabase();
    if (!name.trim() || !id.trim()) {
      alert("Please enter both Name and ID before proceeding.");
      return;
    }

    setLoading(true);
    const filename = `${name}-${id}.json`;
    
    // Use the already-parsed active schema from supabaseClient (single source of truth)
    const userSchema = supabaseSchema || "public";

    // Use helper function to generate folder path with schema
    const folderPath = generateMedADocsFolderPath(year, selectedDate, userSchema);

    const { data, error } = await supabase.storage
      .from(bucketName_files)
      .list(folderPath);

    if (error) {
      console.error("Error checking document:", error.message);
      setLoading(false);
      return;
    }

    const documentExists = data.some((file) => file.name === filename);

    // Generate file path with schema support
    const filePath = await generateMedADocsPath(year, selectedDate, filename, userSchema);

    if (documentExists) {
      alert("A document already exists for this date. Redirecting to it...");
      navigate(`/patient/${id}/edit-document`, { 
        state: { 
          [prompts[0][0]]: name, 
          id, 
          date_: selectedDate,
          filePath: filePath,
          time_: '',
          type: 'FFP' // Default type for new documents
        } 
      });
    } else {
      navigate(`/patient/${id}/edit-document`, { 
        state: { 
          [prompts[0][0]]: name, 
          id, 
          date_: selectedDate,
          filePath: filePath,
          time_: '',
          type: 'FFP' // Default type for new documents
        } 
      });
    }

    setLoading(false);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Enter Document Details</ModalHeader>
        <ModalCloseButton />
        {/* <ModalBody>
          <FormControl>
            <FormLabel>Name</FormLabel>
            <Input
              placeholder="Enter name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </FormControl>

          <FormControl mt={4}>
            <FormLabel>ID</FormLabel>
            <Input
              placeholder="Enter ID"
              value={id}
              onChange={(e) => setId(e.target.value)}
            />
          </FormControl>
        </ModalBody> */}

        <ModalFooter>
          <Button colorScheme="blue" onClick={handleCreateDocument}>
            Create Document
          </Button>
          <Button onClick={onClose} ml={2}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DocumentCreationModal;
